import React, { Component } from 'react';
import { connect } from 'react-redux';
import postscribe from "postscribe";

class Ads extends Component {

    componentDidMount(){
        if(this.props.id){
          const s = document.createElement('script');
          s.async = true;
          s.type = 'text/javascript';
          s.innerHTML = this.script();
          document.getElementById(this.props.id).appendChild(s);
        }
     }

     componentWillReceiveProps(nextProps) {
        if(this.props.id !== nextProps.id){
            document.getElementById(this.props.id).innerHTML = '';
            postscribe('#' + this.props.id, '<script async type="text/javascript">' + nextProps.slave + '</script>');
        }
     }

    script = () => {
         if (this.props.slave && this.props.id){
             return this.props.slave;
         }
     };

     container = () => {
        if(this.props.id) {
          return <div id={this.props.id} />
        }
     }
     render() {
       return (
         <div className="ads">
           {this.container()}
         </div>
       );
     }
}


const mapStateToProps = state => ({
});
export default Ads;



// WEBPACK FOOTER //
// ./src/FO/components/ads/ads.component.js